import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { RequestGenerationAdjustingAdd } from '@shared/dto/generation/_requests/request_generation_duration_adjusting_add';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { update_user_task_locally } from '../_methods/update_user_task_locally';
import { STATE__generation } from '../STATE__generation';

export const remote_generation_duration_adjusting_add = createAsyncThunkSafe<void, RequestGenerationAdjustingAdd>(
  ENUM__network_event_client_to_server.GENERATION_DURATION_ADJUSTING_ADD,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_DURATION_ADJUSTING_ADD, request);
  },
);

export function init_remote_generation_duration_adjusting_add(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_generation_duration_adjusting_add.pending, (state, action) => {
      let { generation_id, user_task_id } = action.meta.arg;

      let generation = state.generations_map.get_or_assert(generation_id, { context: 'generation' });

      generation = generation.clone({
        duration_adjusting: generation.duration_adjusting + CONSTANTS__shared.GENERATION_DURATION_ADJUSTING_STEP,
      });

      FN_GENERATION__update_locally(state, generation);

      let user_task = state.user_tasks_map.get_or_assert(user_task_id, { context: 'user_task' });

      user_task = user_task.clone({
        duration_adjusting: user_task.duration_adjusting + CONSTANTS__shared.GENERATION_DURATION_ADJUSTING_STEP,
      });

      update_user_task_locally(state, user_task);
    })
    .addCase(remote_generation_duration_adjusting_add.rejected, (state, action) => {})
    .addCase(remote_generation_duration_adjusting_add.fulfilled, (state, action: PayloadAction) => {});
}
